import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../services/auth/auth.service';
import Swal from 'sweetalert2';
import { APP_CONFIG, IAppConfig } from '../../../app.config/app.config';
import { GuiMsjService } from 'src/app/services/shared/gui-msj.service';
import { Subscription } from 'rxjs';
import { Translators } from '../../../services/shared/translators.service';

@Component({
  selector: 'app-auth-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  form: FormGroup;
  siteKey: string;
  idioma: Subscription;

  constructor(
    @Inject(APP_CONFIG) private iAppConfig: IAppConfig,
    private authservice: AuthService,
    public guiMsjService: GuiMsjService,
    private translatorService: Translators,
  ) {
    this.createForm();
  }

  ngOnInit() {
    this.siteKey = this.iAppConfig.recaptcha.siteKey;
  }

  get emailNoValido() {
    return this.form.get('email').invalid && this.form.get('email').touched;
  }

  createForm() {
    this.form = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$'),
      ]),
      recaptcha: new FormControl('', Validators.required)
    });
  }

  async resetPassword() {
    if (this.form.invalid) {
      return Object.values(this.form.controls).forEach(control => {
        control.markAsTouched();
      });
    }

    this.authservice.resetPassword(this.form.value.email);
    await this.guiMsjService.msjFormSubmit('Espere');
    Swal.showLoading();
  }
}
